import apiConstants from "../constants/apiConstants";
import { axios } from "../utils/axios";

const baseUrl = process.env.REACT_APP_API_HOST;

// Phone OTP sign-in for portal users; staff keep loginUser in userService.

export const requestOtp = async (phone) => {
  return axios.post(`${baseUrl}/${apiConstants.AUTH_OTP_REQUEST}`, { phone });
};

export const verifyOtp = async (phone, code) => {
  return axios.post(`${baseUrl}/${apiConstants.AUTH_OTP_VERIFY}`, { phone, code });
};

export const me = async () => {
  const response = await axios.get(`${baseUrl}/${apiConstants.AUTH_ME}`);
  return response.data;
};

export const getNotifications = async (unreadOnly = false) => {
  const response = await axios.get(`${baseUrl}/${apiConstants.NOTIFICATIONS}${unreadOnly ? "?unread=1" : ""}`);
  return response.data;
};

export const markNotificationsRead = async (ids) => {
  const response = await axios.post(`${baseUrl}/${apiConstants.NOTIFICATIONS}/read`, { ids });
  return response.data;
};

export const googleConfig = async () => (await axios.get(`${baseUrl}/api/auth/google/config`)).data;
export const googleSignIn = async (credential) => axios.post(`${baseUrl}/api/auth/google`, { credential });
